// bulletinboard only support Japanese
export default {
  "bulletinboard.head.title": "The Shared Bulletin Board | LINK-J",
  "bulletinboard.head.description": "Latest News from LINK-J Special Members",
  "bulletinboard.list.head.siteName": "LINK-J",
  "bulletinboard.list.title": "The Shared Bulletin Board",
  "bulletinboard.list.eventDate": "Event Date",
  "bulletinboard.list.deadline": "Deadline",
  "bulletinboard.list.postDate": "Posted on",
  "bulletinboard.list.poster": "Author",
  "bulletinboard.list.termsNotice.text1":
    "This message board is for LINK-J members and partners with LINK-J. Please click ",
  "bulletinboard.list.termsNotice.text2":
    " for guidelines, terms and conditions.",
  "bulletinboard.list.termsNotice.link": "here",

  "bulletinboard.detail.head.siteName": "The Shared Bulletin Board",
  "bulletinboard.detail.title": "The Shared Bulletin Board",
  "bulletinboard.detail.postDate": "Posted on",
  "bulletinboard.detail.poster": "Author",
  "bulletinboard.detail.eventDate": "Event Date",
  "bulletinboard.detail.eventTime": "Time",
  "bulletinboard.detail.applicationPeriod": "Application Period",
  "bulletinboard.detail.venue": "Venue",
  "bulletinboard.detail.detailsAndApplication": "Details / Application",
  "bulletinboard.detail.externalSiteNote": "（Opens an external site）",
  "bulletinboard.detail.referenceMaterials": "Reference",
  "bulletinboard.detail.organizer": "Organizer",
  "bulletinboard.detail.contactInformation": "Contact",

  "bulletinboard.categories.index": "All Bulletins",
  "bulletinboard.categories.news": "News & Activities",
  "bulletinboard.categories.bulletinboardsPressRelease": "Press Releases",
  "bulletinboard.categories.bulletinboardsRecruit": "Recruitment",
  "bulletinboard.categories.bulletinboardsEvent": "Events",
} as const;
